import VueRouter from "vue-router"
import Login from '../pages/Login.vue'
import Home from '../pages/home/Home.vue'
import Approve from '../pages/approve/Approve.vue'
import VisitReport from '../pages/visit-report/VisitReport.vue'
import CreateReport from '../pages/visit-report/CreateReport.vue'
import CustomerApprove from '../pages/customer/CustomerApprove.vue'
import CustomerInfo from '../pages/customer/CustomerInfo.vue'
import SignCheck from '../pages/checkin/SignCheck.vue'
import ClueList from '../pages/clue/ClueList.vue'
import ClueDetail from '../pages/clue/ClueDetail.vue'
import Vue from 'vue'
import VisitPlanList from "../pages/visit-plan/VisitPlanList.vue"
import CreateVisitPlan from "../pages/visit-plan/CreateVisitPlan.vue"
import Static from "../pages/static/Static.vue"
import {
  Toast,
} from 'vant'
import '../../node_modules/vant/lib/toast/style'
import store from '../store'

Vue.use(Toast)
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [{
      name: 'Login',
      path: '/login',
      component: Login,
      meta: {
        title: '登录'
      }
    }, {
      name: 'Home',
      path: '/home',
      component: Home,
      meta: {
        title: '首页'
      },
    }, {
      name: 'Approve',
      path: '/approve',
      component: Approve,
      meta: {
        title: '审批列表'
      },
    }, {
      name: 'VisitReport',
      path: '/visitReport/:id/:approveType',
      component: VisitReport,
      props: true,
      meta: {
        title: '访问报告',
      }
    }, {
      name: 'CreateReport',
      path: '/createReport',
      component: CreateReport,
      meta: {
        title: '访问报告创建',
      }
    }, {
      name: 'CreateReport',
      path: '/createReport/:planid',
      component: CreateReport,
      props: true,
      meta: {
        title: '访问计划转访问报告',
      }
    }, {
      name: 'CustomerInfo',
      path: '/customer/:id/:clue',
      component: CustomerInfo,
      props: true,
      meta: {
        title: '客户',
      }
    }, {
      name: 'CustomerApprove',
      path: '/customerApprove/:id',
      component: CustomerApprove,
      props: true,
      meta: {
        title: '客户审批',
      }
    }, {
      name: 'SignCheck',
      path: '/signCheck',
      component: SignCheck,
      meta: {
        title: '拜访打卡',
      }
    }, {
      name: 'ClueList',
      path: '/clue',
      component: ClueList,
      meta: {
        title: '线索列表',
      }
    }, {
      name: 'ClueDetail',
      path: '/clueInfo/:id',
      component: ClueDetail,
      props: true,
      meta: {
        title: '线索信息',
      }
    },
    {
      name: 'VisitPlan',
      path: '/visitPlan',
      component: VisitPlanList,
      meta: {
        title: '访问计划列表'
      }
    }, {
      name: 'VisitPlanDetail',
      path: '/visitPlanInfo/:id',
      component: CreateVisitPlan,
      props: true,
      meta: {
        title: '访问计划信息'
      }
    }, {
      name: 'Static',
      path: '/static',
      component: Static,
      props: true,
      meta: {
        title: '客户拜访统计'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('BosUser'))
  //验证token是否过期
  if (user != undefined && user.expireTime > Date.now()) {
    store.dispatch('userAbout/setUser', user)
    if (to.path == "/") {
      next("/home");
    } else {
      next();
    }

  } else {
    if (to.path === "/login"||to.path ==="/static"||to.path ==="/staticMain") {
      next()
    } else{
      if (user != undefined) {
        Toast('用户信息已过期,请重新登录')
      }
      next('/login')
    }
  }
})

export default router